import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './map/map.component';
import {CustomButtonModule} from '../custom-button/custom-button.module';
import { SearchComponent } from './search/search.component';
import { NavigationComponent } from './navigation/navigation.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {FormListGeneratorModule} from '../form-list-generator/form-list-generator.module';



@NgModule({
    declarations: [MapComponent, SearchComponent, NavigationComponent],
  exports: [
    MapComponent,
    SearchComponent,
    NavigationComponent
  ],
  imports: [
    CommonModule,
    CustomButtonModule,
    ClickOutsideModule,
    FormListGeneratorModule
  ]
})
export class MapModule { }
